import { render, staticRenderFns } from "./GraficoVendas.vue?vue&type=template&id=2582bd01"
import script from "./GraficoVendas.vue?vue&type=script&lang=js"
export * from "./GraficoVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports